(function () {
  var matchDayLabel = 'Match Day Price';
  var staleLabelPattern = /^(BACK2CAMP|Spring|Prime|Christmas)( Final Price| Final Sale)?$/i;
  var scheduled = false;
  var primaryGreen = '#1F6F43';
  var hoverGreen = '#185934';
  var stadiumNavy = '#173A2B';
  var benefitsHtml = [
    '<section class="newyear-sale-benefits-section match-day-benefits-section" aria-labelledby="match-day-benefits-title" data-match-day-fallback="true">',
    '  <div class="benefits-container">',
    '    <div class="nysb-header">',
    '      <div class="nysb-title-wrapper">',
    '        <div class="nysb-bg-text" aria-hidden="true">MATCH DAY</div>',
    '        <div class="nysb-header-content">',
    '          <h2 class="nysb-title" id="match-day-benefits-title">Match Day Sale Benefits</h2>',
    '        </div>',
    '      </div>',
    '      <div class="nysb-description">Outdoor comfort, bundle value, and shopping confidence for every BACK2CAMP game day.</div>',
    '    </div>',
    '    <div class="benefits-grid">',
    '      <div class="benefit-card" data-card><div class="benefit-card-bg"></div><div class="benefit-card-content"><div class="benefit-card-icon" data-klaviyo-trigger="XttGeb" role="button" tabindex="0" aria-label="Open lucky draw"><img src="//www.ogery.com/cdn/shop/files/ChatGPT_Image_Jun_22_2026_04_34_07_PM-Photoroom.png?v=1782117696&width=200" alt="Match Day Lucky Draw" width="200" height="200"></div><h3 class="benefit-card-title">Match Day Lucky Draw</h3><p class="benefit-card-description">Every player has a chance to unlock exclusive Match Day rewards.</p></div></div>',
    '      <div class="benefit-card" data-card><div class="benefit-card-bg"></div><div class="benefit-card-content"><div class="benefit-card-icon"><img src="//www.ogery.com/cdn/shop/files/ChatGPT_Image_Jun_22_2026_04_35_48_PM-Photoroom.png?v=1782117912&width=200" alt="Bundle and Save" width="200" height="200"></div><h3 class="benefit-card-title">Bundle & Save</h3><p class="benefit-card-description">Mix cooling fans, lights, and patio gear to build a better game-day setup.</p></div></div>',
    '      <div class="benefit-card" data-card><div class="benefit-card-bg"></div><div class="benefit-card-content"><div class="benefit-card-icon"><img src="//www.ogery.com/cdn/shop/files/30_Image_Jun_22_2026_04_39_04_PM-Photoroom.png?v=1782117913&width=200" alt="30-Day Price Guarantee" width="200" height="200"></div><h3 class="benefit-card-title">30-Day Price Guarantee</h3><p class="benefit-card-description">If the price drops within 30 days, we will refund the difference.</p></div></div>',
    '      <div class="benefit-card" data-card><div class="benefit-card-bg"></div><div class="benefit-card-content"><div class="benefit-card-icon"><img src="//www.ogery.com/cdn/shop/files/return_Image_Jun_22_2026_06_07_51_PM-Photoroom.png?v=1782123113&width=200" alt="Hassle-Free Returns" width="200" height="200"></div><h3 class="benefit-card-title">Hassle-Free Returns</h3><p class="benefit-card-description">Shop your sideline, backyard, and camping setup with 30-day return support.</p></div></div>',
    '    </div>',
  '  </div>',
    '</section>'
  ].join('');

  function relabelButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.xm-btn-label, .xm-main-btn-label').forEach(function (label) {
      var current = (label.textContent || '').trim();
      if (staleLabelPattern.test(current) || current === '' || current === 'Halloween Sale Price') {
        label.textContent = matchDayLabel;
      }
    });
  }

  function applyBrandControls(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.section-xm-products, .xm-section').forEach(function (section) {
      section.style.setProperty('--btn-buy-now-bg', primaryGreen);
      section.style.setProperty('--btn-buy-now-gradient-start', primaryGreen);
      section.style.setProperty('--btn-buy-now-gradient-end', hoverGreen);
      section.style.setProperty('--btn-buy-now-hover-mask', hoverGreen);
      section.style.setProperty('--btn-add-to-cart-bg', primaryGreen);
      section.style.setProperty('--btn-add-to-cart-hover-mask', hoverGreen);
    });

    scope.querySelectorAll('.xm-btn-final-price, .bundle-add-to-cart, .bundle-product-card__add-button').forEach(function (button) {
      button.style.backgroundColor = primaryGreen;
      button.style.backgroundImage = 'none';
      button.style.borderColor = primaryGreen;
      button.style.color = '#ffffff';
    });

    scope.querySelectorAll('.xm-btn-learn-more, .bundle-view-more-btn').forEach(function (button) {
      button.style.borderColor = stadiumNavy;
      button.style.color = stadiumNavy;
    });
  }

  function applyHeroKv(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.section-image-with-text-overlay .match-day-hero-kv').forEach(function (image) {
      image.remove();
    });
  }

  function relabelPageChrome() {
    document.querySelectorAll('a, span, p, div, button').forEach(function (element) {
      if (element.children.length > 2) return;

      element.childNodes.forEach(function (node) {
        if (node.nodeType !== Node.TEXT_NODE) return;
        var text = node.nodeValue || '';
        if (text.indexOf('Prime Day') === -1) return;
        node.nodeValue = text.replace(/Prime Day Sale/g, 'Match Day Sale').replace(/Prime Day/g, 'Match Day');
      });

      if (element.tagName === 'A' && (element.textContent || '').indexOf('Match Day Sale') !== -1) {
        element.setAttribute('href', '/pages/BACK2CAMP-match-day-sale');
      }
    });
  }

  function ensureBenefits() {
    if (document.querySelector('.newyear-sale-benefits-section, .match-day-benefits-section')) return;

    document.querySelectorAll('.match-day-benefits').forEach(function (legacy) {
      var section = legacy.closest('.shopify-section') || legacy;
      section.remove();
    });

    var navSection = document.querySelector('[id*="promotion_elevator_nav"]');
    var navWrapper = document.querySelector('.promotion-elevator-nav__wrapper');
    var target = navSection || (navWrapper && navWrapper.closest('.shopify-section')) || navWrapper;

    if (!target || !target.parentNode) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'shopify-section newyear-sale-benefits match-day-benefits-fallback';
    wrapper.innerHTML = benefitsHtml;
    target.parentNode.insertBefore(wrapper, target);
  }

  function bindFallbackLuckyDraw(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-match-day-fallback] [data-klaviyo-trigger]').forEach(function (icon) {
      if (icon.dataset.matchDayBound === 'true') return;
      icon.dataset.matchDayBound = 'true';
      icon.addEventListener('click', function () {
        var formId = icon.dataset.klaviyoTrigger;
        if (formId && window._klOnsite) window._klOnsite.push(['openForm', formId]);
      });
      icon.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        var formId = icon.dataset.klaviyoTrigger;
        if (formId && window._klOnsite) window._klOnsite.push(['openForm', formId]);
      });
    });
  }

  function scheduleRelabel() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      relabelButtons(document);
      relabelPageChrome();
      applyBrandControls(document);
      applyHeroKv(document);
      ensureBenefits();
      bindFallbackLuckyDraw(document);
    });
  }

  function init() {
    relabelButtons(document);
    relabelPageChrome();
    applyBrandControls(document);
    applyHeroKv(document);
    ensureBenefits();
    bindFallbackLuckyDraw(document);

    var observer = new MutationObserver(scheduleRelabel);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('shopify:section:load', function (event) {
      relabelButtons(event.target || document);
      relabelPageChrome();
      applyBrandControls(event.target || document);
      applyHeroKv(event.target || document);
      ensureBenefits();
      bindFallbackLuckyDraw(event.target || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
